import ApiService from "../../components/Api_services";
import { useEffect, useState } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import FallbackImg from "../FallbackImg";

const HomeBanner = () => {
  //get banner data
  const [banners, setBanners] = useState([]);
  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const bannerData = await ApiService.getAllBanner();
        setBanners(bannerData.data.banner); // or adjust based on actual response shape
      } catch (err) {
        console.error("API Error:", err);
      }
    };

    fetchBanners();
  }, []);

  // Slideshow
  const [slideIndex, setSlideIndex] = useState(0);
  const [slides, setSlides] = useState([]);

  const nextSlide = (n) => {
    setSlideIndex(
      (prevIndex) => (prevIndex + n + slides.length) % slides.length
    );
  };

  const goToSlide = (n) => {
    setSlideIndex(n);
  };

  useEffect(() => {
    if (banners.length > 0) {
      const slideData = banners.map((banner) => ({
        src: banner.photo_url,
        Id: banner.event_id,
      }));
      setSlides(slideData);
    }
  }, [banners]);

  useEffect(() => {
    if (slides.length > 0) {
      const timer = setInterval(() => {
        nextSlide(1);
      }, 5000); // 每5秒切换一次
      return () => clearInterval(timer);
    }
  }, [slides, slideIndex]);

  return (
    <div className="slideshow_v2">
      {slides.map((slide, index) => (
        <div
          key={index}
          className="fade_v2"
          style={{ display: index === slideIndex ? "block" : "none" }}
        >
          <Link to={`/event/${slide.Id}`} className="image-wrapper_v2">
          <div className="image-wrapper_v2">
            <FallbackImg src={slide.src} alt={`slide${index}`} />
            <div className="dots-overlay_v2">
              {slides.map((_, i) => (
                <span
                  key={i}
                  className={`dot ${slideIndex === i ? "active" : ""}`}
                  onClick={() => goToSlide(i)}
                ></span>
              ))}
            </div>
          </div>

          <div className="text_v2">{slide.caption}</div>
          </Link>
        </div>

      ))}

      <button className="prev_v2" onClick={() => nextSlide(-1)}>
        <ArrowLeft size={25} />
      </button>
      <button className="next_v2" onClick={() => nextSlide(1)}>
        <ArrowRight size={25} />
      </button>
    </div>
  );
};

export default HomeBanner;
